import { render, staticRenderFns } from "./fanglz.vue?vue&type=template&id=5020dfe2&scoped=true"
import script from "./fanglz.vue?vue&type=script&lang=js"
export * from "./fanglz.vue?vue&type=script&lang=js"
import style0 from "./fanglz.vue?vue&type=style&index=0&id=5020dfe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020dfe2",
  null
  
)

export default component.exports